import React from 'react';

import PropTypes, { oneOfType } from 'prop-types';
import NumberFormat from 'react-number-format';

import { StyledInputWrapper } from 'components/PortalFormFields/InputFields/styles';
import CurrencySideSymbol from 'components/SideSymbol/CurrencySideSymbol';
import { buildElementIdString } from 'utils/accessibility/buildElementIdString';

const DECIMAL_PRECISION = 2;

const PriceInput = ({
  value,
  hasError,
  onChange,
  onBlur,
  onFocus,
  name,
  label,
  placeholder,
  error,
}) => {
  const handleChange = ({ floatValue }) => onChange(floatValue);

  return (
    <StyledInputWrapper hasError={hasError}>
      <NumberFormat
        onBlur={onBlur}
        name={name}
        onValueChange={handleChange}
        value={value}
        placeholder={placeholder}
        decimalScale={DECIMAL_PRECISION}
        thousandSeparator=" "
        onFocus={onFocus}
        data-testid={name}
        aria-label={label}
        decimalSeparator=","
        autoComplete="off"
        aria-describedby={`${buildElementIdString(name, 'error', error)} ${buildElementIdString(
          name,
          'optional-label',
        )}`}
      />
      <CurrencySideSymbol />
    </StyledInputWrapper>
  );
};

PriceInput.defaultProps = {
  name: null,
  label: null,
  placeholder: null,
  value: null,
  hasError: false,
  onChange: () => null,
  onFocus: () => null,
  error: null,
};

PriceInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  hasError: PropTypes.bool,
  error: oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

export default PriceInput;
